import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/kakutei_01.png")